import Vue from "vue";
export default {
    namespaced: true,
    state: {
        items: [],
        value: null,
    },

    getters: {
        items(state,) {
            return state.items;
        },
    },

    mutations: {
        SET_NULL(state) {
            state.value = null;
        },
        SELECT_CONCEPTO(state, item) {
            state.value = item;
        },
        SET_CONCEPTOS(state, items = []) {
            state.items = items;
        },
        ADD_CONCEPTO(state, concepto) {
            state.items.push(concepto);
        },
        DELETE_CONCEPTO(state, Id) {
            const ind = state.items.findIndex(concepto => concepto.id === Id);
            if (ind !== -1) {
                state.items.splice(ind, 1);
            }
        },

        EDIT_CONCEPTO(state, { Id, concepto }) {
            const ind = state.items.findIndex(concepto => concepto.id === Id);

            if (ind !== -1) {
                Vue.set(state.items, ind, concepto);
            }
        }
    },

    actions: {
        setConceptoNull({ commit }) {
            return (commit('SET_NULL'), true)
        },

        selectConcepto({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item === data);
            return exitsItem ? (commit('SELECT_CONCEPTO', data), true) : false;
        },

        // first param is context object
        setConceptos({ commit }, data) {
            commit('SET_CONCEPTOS', data);
            return true;
        },
        addConcepto({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === data.id);
            return !exitsItem ? (commit('ADD_CONCEPTO', data), true) : false;
        },

        deleteConcepto({ state, commit }, id) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === id);
            return exitsItem ? (commit('DELETE_CONCEPTO', id), true) : false;
        },

        editConcepto({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === data.id);
            return exitsItem ? (commit('EDIT_CONCEPTO', data), true) : false;
        },

    }
};
